import { createFileRoute, redirect, useRouter } from "@tanstack/react-router";
import { AuthCard } from "@/components/auth-card";
import { EnrolTotpForm } from "@/features/staff/enrol-totp/form";
import { staffTotpState } from "@/features/staff/session";
import { m } from "@/lib/paraglide/messages.js";

// Outside the staff boundary: the API refuses the enrolment session everywhere on
// /api/staff (403 totp_required), and this page is what that session is for.
export const Route = createFileRoute("/staff/enrol")({
  beforeLoad: async () => {
    const state = await staffTotpState();
    if (state === "signed-out") throw redirect({ to: "/staff/login" });
    if (state === "enrolled") throw redirect({ to: "/staff" });
  },
  component: EnrolPage,
});

function EnrolPage() {
  const router = useRouter();
  return (
    <AuthCard title={m.staff_enrol_title()} description={m.staff_enrol_description()} area="staff">
      <EnrolTotpForm onEnrolled={() => router.navigate({ to: "/staff" })} />
    </AuthCard>
  );
}
